import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mitteilungs-vorlage-detail';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageDetailEffects {

    MitteilungsVorlageDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MITTEILUNGS_VORLAGE_DETAIL),
        mergeMap((x: ac.GetMitteilungsVorlageDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMitteilungsVorlageDetail(x.id).pipe(
                map((result: any) => {
                    return new ac.GetMitteilungsVorlageDetailErfolgreichAction(result, x.id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMitteilungsVorlageDetailFehlerAction(error, x.id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageQueryService);
        }
        return this.service;
    }
}
